module.exports = __webpack_public_path__ + "img/hospital.db328458.svg";